<template>
    <div :class="itemClass">
        <slot name="title" :title="title" :itemTitleClass="itemTitleClass"
            ><div :class="itemTitleClass">{{ title }}</div></slot
        ><slot />
    </div>
</template>

<script>
export default {
    name: "VtkSidebarItem",
    props: {
        title: {
            type: String,
            required: true
        },
        itemClass: {
            type: [String, Object],
            default: "sidebar-item"
        },
        itemTitleClass: {
            type: [String, Object],
            default: "sidebar-item-title"
        }
    }
};
</script>

<style lang="scss" scoped>
.sidebar-item {
    padding-bottom: 10px;
}

.sidebar-item-title {
    text-align: center;
    padding: 6px;
}
</style>
